new Vue({
    el: '#vue-menus',
    data: {
        lojas: window.vueData.lojas,
        categorias: window.vueData.categorias,
        wldata: window.vueData.wldata,
        filtro: '',
        filtroCategoria: '',
        showAlert: window.vueData.showAlert,
        categoriaSelecionada: window.vueData.categoriaSelecionada
    },
    mounted () {
        if (this.showAlert && !window.sessionStorage.getItem('showAgain')) {
            window.sessionStorage.setItem('showAgain', true);
            window.Swal.fire({
                imageUrl: 'https://demo.negocioso2.com.br/imgs/alerta.png',
                imageAlt: 'Você esta acessando nossa plataforma DEMO!',
                width: 850,
                height: 550,
                showConfirmButton: false
            });
        }
    },
    methods: {
        goTo (id) {
            document.location.href = '/categorias/' + id;
        }
    }
});
